import UserApi from '@/api/UserApi';
import BaseService from '../BaseService';

class UserService extends BaseService {

	async getUserInfosAsync (...args: Parameters<typeof UserApi.getUserInfos>) {
		try {
			const { data } = await UserApi.getUserInfos(...args);
			return data;
		}
		catch {
			return undefined;
		}
	}

	async sendMailResetPasswordAsync (...args: Parameters<typeof UserApi.sendMailResetPassword>) {
		const { data } = await UserApi.sendMailResetPassword(...args);
		return data;
	}

	async updateAsync (...args: Parameters<typeof UserApi.update>) {
		const { data } = await UserApi.update(...args);
		return data;
	}

	async sendEmailActivationAsync (...args: Parameters<typeof UserApi.sendEmailActivation>) {
		const { data } = await UserApi.sendEmailActivation(...args);
		return data;
	}

	async getUserFullInfosAsync (...args: Parameters<typeof UserApi.getUserFullInfos>) {
		const { data } = await UserApi.getUserFullInfos(...args);
		return data;
	}

	async addAsync (...args: Parameters<typeof UserApi.add>) {
		const { data } = await UserApi.add(...args);
		return data;
	}

	async activationDetailsAsync (...args: Parameters<typeof UserApi.activationDetails>) {
		const { data } = await UserApi.activationDetails(...args);
		return data;
	}

	async activateAsync (...args: Parameters<typeof UserApi.activate>) {
		const { data } = await UserApi.activate(...args);
		return data;
	}

	async signupAsync (...args: Parameters<typeof UserApi.signup>) {
		const { data } = await UserApi.signup(...args);
		return data;
	}

}

export default function useUserService () {
	return new UserService();
}
